import React from "react"
import Layout from "components/layouts/layout"
import { useState } from "react"
import ContinueButton from "components/elements/styledButton/ContinueButton"
import PropTypes from "prop-types"
import "./consentpage.css"
import patientIcon from "static/images/patient-graphic.webp"
import caregiverIcon from "static/images/caregiver-graphic.webp"
import insuranceIcon from "static/images/insurance-graphic.webp"
import scheduleIcon from "static/images/scheduling-graphic.webp"
import MorningApptBanner from "utils/morningApptBanner"

const ConsentPage = ({ nextStep }) => {
  const openInNewTab = url => {
    const newWindow = window.open(url)
    if (newWindow) newWindow.opener = null
  }
  const privacy_policy_btn = () => {
    openInNewTab("/privacy-policy")
  }
  const terms_use_btn = () => {
    openInNewTab("/terms-use")
  }
  const showbutton = () => {
    if (nextBtn === true) {
      setNextbtn(false)
    } else {
      setNextbtn(true)
    }
  }
  const NextPageBtn = () => {
    // console.log(user.seeking_evaluation)
    nextStep()
  }
  const [nextBtn, setNextbtn] = useState(false)

  return (
    <Layout>
      <section>
        <div className="consent-welcome">Welcome!</div>
      </section>
      <MorningApptBanner />
      <section>
        <div className="card-container">
          <div className="consent-container">
            <div>
              We&apos;re happy to meet you! To get started, we need to register
              an account for your child and then get you scheduled. We accept
              new patients from birth to 17.5 years of age at all of our
              centers. Your information is secure with us, and we never share it
              without your permission.
            </div>
          </div>
          <div className="col-md-12 consent-container">
            <div className="form-check">
              <input
                className="model_checkbox"
                id="myCheck"
                onClick={showbutton}
                type="checkbox"
                value=""
              />
              <label className="model_level">
                I consent to the{" "}
                <span
                  aria-hidden="true"
                  className="anchor_link"
                  onClick={terms_use_btn}
                >
                  terms of use
                </span>{" "}
                and have read the{" "}
                <span
                  aria-hidden="true"
                  className="anchor_link"
                  onClick={privacy_policy_btn}
                >
                  privacy policy.
                </span>
              </label>
            </div>
          </div>
          <div className=" continue-container">
            {" "}
            <ContinueButton disabled={!nextBtn} onClick={NextPageBtn} />
          </div>
        </div>
      </section>
      <section>
        <div className="progress-stickers-container">
          <div className="progress-stickers">
            <img alt="patient icon" src={patientIcon}></img>
            <div className="progress-steps">
              <p>Step 1. Patient</p>
              <p> Information</p>
            </div>
          </div>
          <div className="progress-stickers">
            <img alt="caregiver icon" src={caregiverIcon}></img>
            <div className="progress-steps">
              <p>Step 2. Caregiver</p>
              <p> Information</p>
            </div>
          </div>
          <div className="progress-stickers">
            <img alt="insurance icon" src={insuranceIcon}></img>
            <div className="progress-steps">
              <p>Step 3. Insurance</p>
            </div>
          </div>
          <div className="progress-stickers">
            <img alt="scheduling icon" src={scheduleIcon}></img>
            <div className="progress-steps">
              <p>Step 4. Scheduling</p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}
ConsentPage.propTypes = {
  nextStep: PropTypes.func.isRequired,
}
export default ConsentPage
